import { useState, useCallback } from 'react';
import ResizableModal from '../../../../../ui/ResizableModal';
import BukIntegrationContent from '../../../Ajustes/Integraciones/BukIntegrationContent';

const ModalConectarBuk = ({ open, setOpen, onIntegrationComplete }) => {
  const [footerContent, setFooterContent] = useState(null);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleCloseBackground = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      width={900}
      height={700}
      footer={footerContent}
    >
      <BukIntegrationContent
        isModal={true}
        onClose={handleClose}
        onCloseBackground={handleCloseBackground}
        onFooterChange={setFooterContent}
        onIntegrationComplete={onIntegrationComplete}
      />
    </ResizableModal>
  );
};

export default ModalConectarBuk;
